export default __webpack_public_path__ + "8cb24f494cc4de9e1a7a8525e76dddcf.png";